import { createFileRoute } from "@tanstack/react-router";
import FrontchannelLogout from "@/components/navigation/FrontchannelLogout";

// 検索パラメータの型を定義
interface LogoutSearchParams {
  sid?: string;
  iss?: string;
}

export const Route = createFileRoute("/logout")({
  validateSearch: (search: Record<string, unknown>): LogoutSearchParams => {
    return {
      sid: search.sid as string | undefined,
      iss: search.iss as string | undefined,
    };
  },
  component: FrontchannelLogoutWrapper,
});

// URLパラメータを受け取るラッパー
function FrontchannelLogoutWrapper() {
  const search = Route.useSearch();
  const sessionId = search.sid;
  const issuer = search.iss;

  return <FrontchannelLogout sessionId={sessionId} issuer={issuer} />;
}
